import { WPClient } from "../wp/client/WPClient";
import { ZitateGridModuleType } from "../modules/QuotesGrid/QuotesGrid.server";
import { QuotesElementType } from "@/modules/QuoteSliderModule/QuoteSliderModule";
import { requireDefined } from "@/utils/envs";

/* jscpd:ignore-start */
interface FetchPostsProps {
  page: number;
  postsPerPage: number;
  offset: number;
  locale: string | undefined;
  module: ZitateGridModuleType;
}
/* jscpd:ignore-end */

export const fetchQuotes = async ({
  page,
  postsPerPage,
  offset,
  locale,
  module,
}: FetchPostsProps) => {
  const defaultLocale = requireDefined(process.env.NEXT_PUBLIC_DEFAULT_LOCALE);
  const client = new WPClient({ locale, defaultLocale });
  const { quotes, type } = module.quotes_grid || {};

  const postsResult = await client.getPosts({
    type: "quotes",
    page: page,
    perPage: postsPerPage,
    offset,
    fields: ["id", "acf.header_quotes"],
    ...(type === "quotes" && {
      includeIds: { ids: quotes || [], keepOrder: true },
    }),
  });

  const fetchedPosts = postsResult.posts.map((post) => {
    const header = post.acf?.header_quotes;
    return {
      title: header?.title || "",
      content: header?.content || "",
      name: header?.name || "",
      position: header?.position || "",
      firma: header?.firma || "",
      image: header?.image || false,
      preview_image: header?.preview_image || false,
      rating_stars: header?.rating_stars || false,
      source: {
        type: header?.source.type,
        logo: header?.source.logo || false,
        text: header?.source.text || "",
      },
    } as QuotesElementType;
  });

  return {
    posts: fetchedPosts,
    totalPosts: postsResult.totalPosts,
  };
};
